/**
@format
@flow
*/

import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { Heading } from '@ziynx/components/typography';
import { ContentContainer } from '@ziynx/components/layout';

const PageWrapper = styled.div`
  padding: 40px;
`;

const TextStatement = (): React$Node => (
  <>
    <Helmet>
      <title>Customize Statement | ZIYNX</title>
    </Helmet>
    <ContentContainer>
      <PageWrapper>
        <Heading large>Customize statement question</Heading>
      </PageWrapper>
    </ContentContainer>
  </>
);

export default TextStatement;
